import { render, staticRenderFns } from "./OrdersPage.vue?vue&type=template&id=bcd04a40&scoped=true&"
import script from "./OrdersPage.vue?vue&type=script&lang=js&"
export * from "./OrdersPage.vue?vue&type=script&lang=js&"
import style0 from "./OrdersPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrdersPage.vue?vue&type=style&index=1&id=bcd04a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd04a40",
  null
  
)

export default component.exports